export const MOBILE_APK_FILE_NAME = 'baobab-manager.apk';

export function getMobileApkUrl(): string {
  return '/m-app/app.apk';
}

/** Live shop — login is unauthenticated; DEV shop sits behind Basic Auth. */
export const SHOP_LEGAL_ORIGIN = 'https://www.gewuerze-der-welt.net';

export function getShopPageUrl(slug: string): string {
  return `${SHOP_LEGAL_ORIGIN}/${slug.replace(/^\//, '')}`;
}
